import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { IProductPhotosGETModel, IProductPhotosPOSTModel, IProductPhotosPUTModel } from "../../models/product/dto/photos/product-photos.model";
import { map } from "rxjs/operators";
import { ProductPhotosMapping } from "../../mappings/product/product-photos/product-photos.mapping";

@Injectable({
    providedIn: 'root'
})
export class ProductPhotosService {
    fullPath: string;
    private mapping: ProductPhotosMapping;

    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/Products`;
        this.mapping = new ProductPhotosMapping();
    }

    public get(id: number): Observable<IProductPhotosGETModel[]> {
        return this.httpClient.get<any>(`${this.fullPath}/${id}/images`).pipe(
            map(dto => dto['items'].map((dto: IProductPhotosGETModel) => this.mapping.toApplicationModel(dto)))
        );
    }

    public getSourceImage(productId: number, imageId: number): Observable<string> {
        return this.httpClient.get(`${this.fullPath}/${productId}/images/${imageId}/sourceImageUrl`, {responseType: 'text'})
    }

    public save(id: number, model: IProductPhotosPOSTModel): Observable<IProductPhotosPOSTModel> {
        return this.httpClient.post<IProductPhotosPOSTModel>(`${this.fullPath}/${id}/images`, model);
    }

    public update(productId: number, model: IProductPhotosPUTModel): Observable<IProductPhotosPUTModel> {
        return this.httpClient.put<IProductPhotosPUTModel>(`${this.fullPath}/${productId}/images/${model.imageId}`, model);
    }

    public delete(ids: number[], productId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                productId: productId,
                imageIds: ids
            }
        };
        return this.httpClient.delete<boolean>(`${this.fullPath}/${productId}/images`, httpOptions);
    }
}